// v0.4.7+: forum src 2.0 化 (辉哥 2026-07-20 21:38 拍板, 砍 1.8 兼容)
//   - `import app from 'flarum/app'` → `import app from 'flarum/common/app'`
//     (2.0 vendor 走 flarum-webpack-config externals alias 解析成
//     `flarum.core.compat['app']' 字符串, 2.0 vendor 设了兼容)
//   - 删 `import RouteIndex from 'flarum/forum/components/RouteIndex'` 死引用
//     (2.0 vendor 移除 RouteIndex 概念, 路由统一走 routes.ts;
//     原 import 是死引用, dist 走 webpack externals alias 解析成
//     `flarum.core.compat['forum/components/RouteIndex']' 字符串, 2.0 vendor 没设
//     这个 key, runtime throw)
import app from 'flarum/common/app';
export function initializeApp() {
  // Common utilities
}
app.initializers.add('ziven-seedream-common', function () {
  // Initialize common functionality
});
export default {
  initializeApp
};